import * as React from 'react';
import { useEffect } from 'react';
import api from "../../utils/api_v2";
import LodingData from "../../utils/LodingData";
import * as util from "../../utils/util";
import Top from "../Top";
import Bottom from "../Bottom";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import icon_inspection1 from "../../assets/images/infor_01.png";
import icon_inspection2 from "../../assets/images/infor_02.png";
import icon_inspection3 from "../../assets/images/infor_03.png";
import icon_inspection4 from "../../assets/images/infor_04.png";
import icon_inspection5 from "../../assets/images/infor_05.png";
import icon_inspection6 from "../../assets/images/infor_06.png";
import icon_inspection7 from "../../assets/images/infor_07.png";
import icon_inspection8 from "../../assets/images/infor_08.png";
import icon_inspection9 from "../../assets/images/infor_09.png";
import icon_inspection10 from "../../assets/images/infor_10.png";
import icon_inspection11 from "../../assets/images/infor_11.png";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import HealthResultItem from "./HealthResultItem";
import HealthResultTotal from "./HealthResultTotal";
import HealthResultCompare from "./HealthResultCompare";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';


import tabbg from "../../assets/images/tab_02.png"


const HealthMResult = () => {
  const navigate = useNavigate();
  const [resultData, setResultData] = React.useState([]);
  const [ownerFamID, setOwnerFamID] = React.useState('');
  const [memberName, setMemberName] = React.useState('비회원');
  const [isFrist, setIsFrist] = React.useState(true);

  useEffect(() => {

    setOwnerFamID(localStorage.getItem('ownerFamID') || '');
    const userCusID = localStorage.getItem('userCusID') || '';
    api.post('customer/api/v1/CU_005_001', { cusId: userCusID }).then(res => {
      if (res.data.length > 0) {
        for (let tp of res.data) {
          if (tp.famId === localStorage.getItem('ownerFamID') || '') {  // 본인 검진 결과만 조회
            LodingData(() => api.post('customer/api/v1/CU_005_002', { famId: tp.famId }).then(res => {
              let resultTemp = res.data.map((v: any) => true ? { ...v, famName: tp.famName, famId: tp.famId } : v);
              setResultData((prev) => prev.concat(resultTemp).sort(compare).reverse());
            }).catch(function (error) {
              console.log(error)
            }).finally(() => {
              setIsFrist(false);
            }));
          }
        }
      } else {
        LodingData(() => { }).finally(() => setIsFrist(false));
      }
    }).catch(function (error) {
      console.log(error)
    });

    api.get('permission/getProfile').then((res: any) => {
      setMemberName(res.data.name);
    }).catch(function (error: any) {
      console.log(error)
    });

  }, []);

  function compare(a: any, b: any) {
    if (a.year < b.year) {
      return -1;
    }
    if (a.year > b.year) {
      return 1;
    }
    return 0;
  }


  const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }

  return (
    <Container className='container'>
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#b2f7ab', fontWeight: 900, }}>
              검진결과
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ee725', fontWeight: 500, }} gutterBottom>
              주요결과
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <ButtonGroup
        disableElevation
        variant="contained"
        aria-label="Disabled button group"
        sx={{ justifyContent: 'center', width: '100%' }}
      >
        <Box sx={{ width: '80%', background: '#ccc !important', '& a': { width: '50%!important', }, '& a:hover': { bgcolor: '#074300 !important' } }}>
          <Button href="../MyPage/HealthResult" sx={{ bgcolor: '#ccc' }}>종합결과</Button>
          <Button href="../MyPage/HealthMResult" sx={{ bgcolor: '#0d6703 !important', border: '1px solid #0d6703 !important' }}>주요결과</Button>
        </Box>
      </ButtonGroup>

      {/* <Stack direction={'row'} >
            <Typography sx={{ fontSize: 16, fontWeight: 700 }}>검진결과 내역</Typography>
            <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#555', ml: 'auto' }} />
          </Stack>
          <Divider sx={{ mt: 1, mb: 1.5 }} /> */}

      {
        isFrist
          ? null
          : <Card sx={{ borderRadius: 3, mt: 4, width: '80%', ml: 'auto', mr: 'auto', p: '20px 0px' }}>
            <Stack direction={'column'} justifyContent={'space-evenly'} alignItems={'center'}>
              <Typography sx={{ fontSize: 16, fontWeight: 700, mb: 2 }}>{memberName}<Typography component={'span'} sx={{ fontSize: 14 }}> 님의 검진 결과 </Typography></Typography>

              <Divider sx={{ mb: 4, width: '100%' }}>
                <Chip icon={<LocalHospitalIcon />} label={resultData.filter((v: any) => v.famId === ownerFamID).length + ' 건'} sx={{ width: 90, pl: '5px' }} />
              </Divider>

              {
                resultData.filter((v: any) => v.famId === ownerFamID).length > 0 ? (
                  <Card sx={{ mt: 2, border: '1px solid #0d6703', py: .5, px: 2, borderRadius: 5, }}>
                    <HealthResultCompare
                      componentName={'최근 3년 결과 비교'}
                      anchor="bottom" />
                  </Card>
                ) : null
              }
            </Stack>
          </Card>
      }


      {
        isFrist
          ? null
          : resultData.length <= 0
            ? (
              localStorage.getItem('hraSurvey') == 'true'
                ? <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, width: '80%', ml: 'auto', mr: 'auto' }}>
                  <ContentPasteOffIcon sx={{ fontSize: 50, color: '#bbb' }} />
                  <Typography sx={{ fontSize: 16, color: '#888' }} >뇌심혈관질환 발병위험도평가 완료 후 검진 결과를 열람하실 수 있습니다.</Typography>
                  <Box sx={BtnStyle}>
                    <Button variant="contained" sx={BottomBtnStyle} onClick={() => { navigate('/hra') }}>
                      평가하기
                    </Button>
                  </Box>
                </Stack>
                : <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, width: '80%', ml: 'auto', mr: 'auto' }}>
                  <ContentPasteOffIcon sx={{ fontSize: 50, color: '#bbb' }} />
                  <Typography sx={{ fontSize: 16, color: '#888' }} >검사 결과가 없습니다.</Typography>
                </Stack>
            )
            : (
              resultData && resultData.map((result: any, index: any) => (
                <Card sx={{ borderRadius: 3, mt: 4, width: '80%', ml: 'auto', mr: 'auto' }}>

                </Card>
              ))
            )
      }


      <Bottom />
    </Container >
  );
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 8,
  boxSizing: 'border-box',
  width: '80%',
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#0d6703',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #0d6703',
  ':hover': {
    backgroundColor: '#074300',
    borderColor: '#074300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#074300',
    borderColor: '#074300',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default HealthMResult;